import React, { FC, useEffect, useState } from "react";
import { Routes, Route, Link } from "react-router-dom";
import styled from "styled-components";
import { useLocation } from 'react-router-dom';
import Tomorrow from "./Projects/tomorrow";

import Header from "../Common/Header";
import Title from "../Common/Title";

const Wrapper = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;

`;
const Content = styled.div`

`;

const NotMatchedBox = styled.div`
    margin-top: 12px;
    width: 100%;
    text-align: center;
    font-size: 1.6rem;
    font-weight: 600;
`;
const NotMatched:FC = () => {
    return (
        <NotMatchedBox>
            작성되지 않은 Path입니다.
        </NotMatchedBox>
    );
}

const Navi = styled.nav`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    & ul {
        width: 100%;
        list-style-type: none;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        overflow: hidden;
        & li a {
            color: var(--text-color);
            text-decoration: none;
            position: relative;
            
            overflow: hidden;
            &::before {
                content: '';
                width: 100%;
                height: 100%;
                border-bottom: 1px solid var(--text-color);
                position: absolute;
                top: 0;
                left: -100%;
                transition: 0.2s;
                overflow: hidden;
                opacity: 0;
            }

            &:hover {
                &::before {
                    transform: translateX(100%);
                    opacity: 1;
                }
            }
        }
    }
`;

const Detail:FC = () => {
    const ContentDict: { [key: string]: string } = {
        tomorrow: "내일의 모든 것",
        goodrecord: "Good Record",
        katalkview: "카톡뷰",
        util: "구내 식당 메뉴 가져오기"
    }
    const [detailUrl, setDetailUrl]         = useState('');
    const [detailContent, setDetailContent] = useState('');
    const location = useLocation();
    useEffect(() => {
        const path = location.pathname.split('/');
        if(path.length < 3) return;
        else {
            const content = path[2];
            if(content && Object.keys(ContentDict).includes(content)) {
                setDetailContent(ContentDict[content]);
                setDetailUrl(content);
            }
            else return;
        }
        // eslint-disable-next-line
    }, []);

    return (
        <Wrapper>
            { (detailContent === '' || !detailContent) ? <Header /> : <Header content={detailContent} headerLink={`/detail/${detailUrl}/`} /> }
            {/* <Title desc="Detail" /> */}
            <Content>
                {
                    (detailUrl !== '' && Object.keys(ContentDict).includes(detailUrl)) && 
                    (
                        <Navi>
                            <ul>
                                <li><Link to={`/detail/${detailUrl}/intro`}>소개</Link></li>
                                <li><Link to={`/detail/${detailUrl}/skills`}>관련 기능</Link></li>
                                <li><Link to={`/detail/${detailUrl}/releasenote`}>릴리즈 노트</Link></li>
                            </ul>
                        </Navi>
                    )
                }
                <Routes>
                    <Route path="/tomorrow/*" element={<Tomorrow />} />
                    <Route path="*" element={<NotMatched />} />
                </Routes>
            </Content>
        </Wrapper>
    );
};

export default Detail;